'use client';

var translations = {
    Follow: 'Theo dõi',
    followers: 'lượt theo dõi',
    follower: 'lượt theo dõi',
    Following: 'Đang theo dõi',
    'opening jobs': 'việc làm',
    'opening job': 'việc làm',
    'Trusted company': 'Công ty uy tín'
};

export { translations as default };
//# sourceMappingURL=translation.js.map
